module.exports = __webpack_public_path__ + "static/media/wilf.97682201.jpg";